<template>
  <b-row>
    <b-col>
      <b-row class="mb-50">
        <b-col>
          <div style="display:flex;justify-content: center;">
            <h4>
              Detalhamento dos status por equipe
            </h4>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                :title="descricao"
                style="font-size: 0.85rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        class="mb-3"
        style="align-items: center;"
      >
        <b-col cols="6">
          <span>Total de documentos: {{ documentosTotal }} [100%]</span>
        </b-col>
        <b-col cols="auto">
          <flat-pickr
            v-model="competencia"
            class="form-control"
            :config="options"
            @on-change="onChange"
          />
        </b-col>
      </b-row>
      <b-row
        class="mb-2"
        align-h="center"
      >
        <b-col
          v-for="(statusEquipe, $index) in statusEquipes"
          :key="$index"
          cols="2"
          style="display: flex;flex-direction: column;align-items: center;"
        >
          <span style="font-weight: bold;">{{ statusEquipe.statusDescricao }}</span>
          <donut-chart-progresso
            :id="$index"
            :dados="statusEquipe"
            :total="statusEquipe.totalDocumentoStatus"
          />
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col
          v-for="(equipe, $index) in equipesNome"
          :key="`${$index}${equipe}`"
          cols="auto"
          style="display: flex;align-items: center;"
        >
          <div
            :style="`background-color:${equipesCor[$index]}`"
            :class="['square', {'opcao-branca': equipesCor[$index] === '#FFFFFF'}]"
          />
          <span>{{ equipe }}</span>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.square {
  height: 10px;
  width: 10px;
  margin-right: 0.5rem;
}

.opcao-branca{
  border: 1px solid #82868b !important;
}
</style>

<script>
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import flatPickr from 'vue-flatpickr-component'
import api from '@/app-modulo/documento/dashboard-cobranca/shared/services/api'

export default {
  name: 'DetalhamentoStatusEquipe',
  components: {
    flatPickr,
    FontAwesomeIcon,
    DonutChartProgresso: () => import('@/shared/components/donutchart-progresso/DonutChartProgresso.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      carregado: false,
      competencia: [],
      options: {
        mode: 'range',
        dateFormat: 'm/Y',
        // eslint-disable-next-line global-require
        locale: require('flatpickr/dist/l10n/pt').default.pt,
      },
      now: new Date(),
      datasFiltro: [],
      statusEquipes: [],
      documentosTotal: null,
      equipesNome: [],
      equipesCor: [],
      descricao: 'Status consolidados dos documentos recorrentes de empresas ativas, por equipe.',
    }
  },
  created() {
    this.competencia.push(new Date(this.now.getFullYear(), this.now.getMonth() - 1))
    this.datasFiltro.push(moment(new Date(this.now.getFullYear(), this.now.getMonth() - 1)).format('DD/MM/YYYY'))
    this.carregaDados()
  },
  methods: {
    carregaDados() {
      api.getStatusEquipes(this.datasFiltro)
        .then(payload => {
          this.statusEquipes = payload.data
          this.documentosTotal = payload.data[0].totalDeDocumentos
          let semEquipe = false
          this.statusEquipes.forEach(each => {
            let indice = 0
            each.equipesNomes.forEach(eac => {
              const index = this.equipesNome.indexOf(eac)
              if (index === -1 && eac !== 'Sem equipe') {
                this.equipesNome.push(eac)
                this.equipesCor.push(each.cores[indice])
              } else if (eac === 'Sem equipe') {
                semEquipe = true
              }
              indice += 1
            })
          })

          if (semEquipe) {
            this.equipesNome.push('Sem equipe')
            this.equipesCor.push('#8f5e3b')
          }
          this.carregado = true
        })
    },
    onChange(selectedDates, dateStr) {
      if (selectedDates && selectedDates.length === 2) {
        this.equipesNome = []
        this.equipesCor = []
        this.statusEquipes = []
        this.datasFiltro = []
        this.datasFiltro = dateStr.split(' até ')
        this.carregaDados()
      }
    },
  },
}
</script>
